import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconMoreVertical(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M12 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm2 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
